const SOUND_PATHS = {
  notification: "/sounds/notif-2.mp3",
  questCompleted: "/sounds/quest-completed.mp3",
  success: "/sounds/success.mp3",
} as const;

export type SoundName = keyof typeof SOUND_PATHS;

type PlaySoundOptions = {
  stopAfterMs?: number;
  volume?: number;
};

function clampVolume(volume?: number) {
  if (typeof volume !== "number" || Number.isNaN(volume)) {
    return 0.3;
  }

  return Math.min(1, Math.max(0, volume));
}

function getStopAfterMs(stopAfterMs?: number) {
  if (
    typeof stopAfterMs !== "number" ||
    !Number.isFinite(stopAfterMs) ||
    stopAfterMs <= 0
  ) {
    return null;
  }

  return stopAfterMs;
}

export function playSound(
  soundName: SoundName,
  options: PlaySoundOptions = {},
) {
  if (typeof Audio === "undefined") {
    return;
  }

  try {
    const audio = new Audio(SOUND_PATHS[soundName]);
    audio.preload = "auto";
    audio.volume = clampVolume(options.volume);

    const stopAfterMs = getStopAfterMs(options.stopAfterMs);
    if (stopAfterMs !== null) {
      globalThis.setTimeout(() => {
        try {
          audio.pause();
          audio.currentTime = 0;
        } catch {
          // Audio is progressive enhancement; a failed stop should not affect UI.
        }
      }, stopAfterMs);
    }

    const playPromise = audio.play();
    if (playPromise && typeof playPromise.catch === "function") {
      void playPromise.catch((error) => {
        console.warn(`Failed to play ${soundName} sound.`, error);
      });
    }
  } catch (error) {
    console.warn(`Failed to initialize ${soundName} sound.`, error);
  }
}
